import List from '@mui/material/List';
import {memo} from 'react';

const MUIList = (props: any) => {
    const {className, children, ...rest} = props;
    return (
        <List className={className} {...rest}>
            {children}
        </List>
    );
};

export default memo(MUIList);
